<template>
<div class="galleryDiv">
    <NavBar/>
    <div class="hero">
        <br><br><br><br><br><br><br><br><br><br>
        <br><br>
        <b-container class="container ">
            <b-row>
                <b-col cols="12">
                    <carousel :per-page="2" :paginationEnabled="false" :navigationEnabled="true" :scrollPerPage="false" :loop="true" :navigationNextLabel="blue">
                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/babyCrate2.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/mutant.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/news.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/shop.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/babyDuck.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/cosmicFusion.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/merch.jpeg' alt="">
                            </slide>


                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/crateCoin.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/fusionCrate.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/genCrate.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/group.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/lootGenBaby.png' alt="">
                            </slide>

                            <slide class="slider">
                                <img class="imgSlider" src='../assets/gallery/cosmicColl.png' alt="">
                            </slide>

                    </carousel>
                </b-col>
            </b-row>
        </b-container>
        <br><br><br>
        <br><br><br>
    </div>
    <Footer/>
</div>
</template>

<script>

import NavBar from './Navigation/NavBar.vue'
import Footer from './Navigation/Footer.vue'
export default {
    components:{
        NavBar,
        Footer
    },
    created() {
    window.location.href = "https://chimbastudios.com/cosmic-labs"; // Replace with your desired URL
  },
    mounted()
    {
        $(document).ready(function(e) {
            const prev = document.getElementsByClassName('VueCarousel-navigation-prev');
            const next = document.getElementsByClassName('VueCarousel-navigation-next');

            prev[0].style.color="#f10fff"
            next[0].style.color="#f10fff"

            prev[0].style.outline="2px solid #f10fff"
            next[0].style.outline="2px solid #f10fff"


            prev[0].addEventListener("focus", function () {
                this.style.outline = "2px solid #f10fff";  
            });

            next[0].addEventListener("focus", function () {
                this.style.outline = "2px solid #f10fff";  
            });
        });
        
    }
}
</script>

<style scoped>
.galleryDiv
{
    background: url('../assets/gallery/bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    perspective: 1000px;
}

.imgSlider
{
    width: 50vh;
    margin: 100px auto 0;
    border: 4px solid #5E5DF0;
}
.imgSlider:hover
{
    transform:
    perspective(50vh)
    rotateX(15deg);
    box-shadow:
        #8888f0 0px 60px 123px -25px,
        #7b7be2 0px 35px 75px -35px;
    border-radius: 10px;
    border: 4px solid #4f4ff5;
}


</style>


// WEBPACK FOOTER //
// src/components/Gallery.vue